import moment from 'moment';

import { ActionType } from '../../classes/action-type';
import { IEventFilter } from '../../classes/calendar';
import { IEvent, IMonth, IOption } from '../../interfaces';

/**
 * Update the Mini-Calendar to show the next month of dates.
 * 
 * Loads the next month if it's not already loaded.
 */
export function nextMonth() {
    return {
        type: ActionType.NextMonth
    }
}

/**
 * Update the Mini-Calendar to show the previous month of dates.
 */
export function previousMonth() {
    return {
        type: ActionType.PreviousMonth
    }
}

/**
 * Update the Sticky-Nav's displayed month based on current scroll position.
 */
export function updateScrolledDate(to: moment.Moment) {
    return {
        type: ActionType.UpdateScrolledDate,
        value: to
    };
}

/**
 * Update mini-calendar and list's current date
 */
export function setDate(newDate: moment.Moment) {
    return {
        type: ActionType.SelectedDate,
        value: newDate
    }
}

export function setCurrentMonth(newDate: moment.Moment) {
    return {
        type: ActionType.SetCurrentMonth,
        value: newDate
    }
}

/**
 * Load more dates (removes the restricted range if one is applied)
 */
export function loadMore() {
    return {
        type: ActionType.LoadMore
    }
}

export function setEventType(eventType: string) {
    return {
        type: ActionType.SetEventType,
        value: event
    }
}

export function goToMonth(month: moment.Moment) {
    return {
        type: ActionType.GoToMonth,
        value: month
    }
}


export function updateGridEvents(events: IMonth<IEvent>[]) {
    return {
        type: ActionType.UpdateGridEvents,
        value: events
    }
}
/**
 * Save events from API into the store
 */
export function updateEvents(loadedMonth: string, month: IMonth<IEvent>) {
    return {
        type: ActionType.UpdateEvents,
        value: {
            loadedMonth,
            month
        }
    }
}

export function updateNextMonthEvents(loadedMonth: string, month: IMonth<IEvent>) {
    return {
        type: ActionType.UpdateNextMonthEvents,
        value: {
            loadedMonth,
            month
        }
    }
}

/**
 * Single action to modify the `updating` property based on the new state
 */
export function checkIfUpdating() {
    return {
        type: ActionType.CheckIfUpdating
    }
}

/**
 * Called after `LoadMore` / `NextMonth`, used to check whether additional dates need to be loaded
 */
export function checkIfNewMonth() {
    return {
        type: ActionType.CheckIfNewMonth
    }
}

export function upsertEventFilter(filterFunction: IEventFilter, shouldUpdateQuery: boolean) {
    return {
        type: ActionType.UpdateEventFilter,
        value: {
            function:
                filterFunction,
            shouldUpdateQuery: shouldUpdateQuery
        }
    }
}

export function removeEventFilter(filterKey: string) {
    return {
        type: ActionType.RemoveEventFilter,
        value: filterKey
    }
}

/**
 * Reset all filters' `selectedOptions` properties to []
 */
export function removeAllEventFilters() {
    return {
        type: ActionType.RemoveAllEventFilters
    }
}

/// MAY NOT BE NEEDED ANYMORE

/**
 * Update the Type Filter's selected option
 */
export function updateTypeFilter(selectedTypeOption: number) {
    return {
        type: ActionType.UpdateEventFilter,
        value: selectedTypeOption
    };
}

/**
 * Update the Checkbox-based filters' selected options
 */
export function updateEventFilter(selectedGenreOptions: number[], selectedVenueOptions: number[], selectedAvailabilityOptions: number[]) {
    return {
        type: ActionType.UpdateEventFilter,
        value: {
            selectedGenreOptions,
            selectedVenueOptions,
            selectedAvailabilityOptions
        }
    }
}



/**
 * Open the filters modal
 */
export function openFiltersDialog(trigger: HTMLButtonElement) {
    return {
        type: ActionType.OpenFiltersDialog,
        value: trigger
    }
}

/**
 * Close the filters modal
 */
export function closeFiltersDialog() {
    return {
        type: ActionType.CloseFiltersDialog
    }
}

/**
 * Open the mini-calendar modal (only works on mobile)
 */
export function openMiniCalDialog(trigger: HTMLButtonElement) {
    return {
        type: ActionType.OpenMiniCalDialog,
        value: trigger
    }
}

/**
 * Close the mini-calendar modal (called automatically if the screen resizes to larger than mobile)
 */
export function closeMiniCalDialog() {
    return {
        type: ActionType.CloseMiniCalDialog
    }
}

/**
 * Update the Type Filter with new options
 */
export function saveTypeFilterOptions(options: IOption[]) {
    return {
        type: ActionType.SaveTypeFilterOptions,
        value: options
    }
}

/**
 * Update the Genre Filter with new options
 */
export function saveGenreFilterOptions(options: IOption[]) {
    return {
        type: ActionType.SaveGenreFilterOptions,
        value: options
    }
}

/**
 * Update the Partner Filter with new options
 */
export function savePartnerFilterOptions(options: IOption[]) {
    return {
        type: ActionType.SavePartnerFilterOptions,
        value: options
    }
}

/**
 * Update the Accessibility Filter with new options
 */
export function saveVenueFilterOptions(options: IOption[]) {
    return {
        type: ActionType.SaveVenueFilterOptions,
        value: options
    }
}

/**
 * Update the Discount Filter with new options
 */
export function saveAvailabilityFilterOptions(options: IOption[]) {
    return {
        type: ActionType.SaveAvailabilityFilterOptions,
        value: options
    }
}
